function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Facebook = function Facebook(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 40 40",
    a11yTitle: "Facebook"
  }, props), React.createElement("path", {
    d: "m17.06 33.17v-12.18h-4.08v-4.84h4.08v-3.81c0-4.14 2.53-6.4 6.23-6.4 1.77 0 3.29.13 3.74.19v4.33h-2.56c-2.01 0-2.4.96-2.4 2.36v3.34h4.54l-.62 4.84h-3.92v12.18"
  }));
};